import { render, staticRenderFns } from "./BillingName.vue?vue&type=template&id=2b23b950"
import script from "./BillingName.vue?vue&type=script&lang=js"
export * from "./BillingName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports